import { Redirect, Route } from "react-router-dom";
import GroupBrowse from "./pages/GroupBrowse";
import GroupDetail from "./pages/GroupDetail";
import PresetsBrowse from "./pages/PresetsBrowse";
import PresetDetail from "./pages/PresetDetail";

/**
 * Build the ordered list of `<Route>` children for the IonRouterOutlet.
 *
 * IMPORTANT: every entry MUST be a real React element. Ionic's StackManager
 * iterates the outlet's children with `React.Children.forEach` and reads
 * `child.props` on each one — and React.Children passes the callback `null`
 * for any falsy child. So a `false`/`null`/`undefined` child (e.g. the result
 * of `{flag && <Route/>}` when `flag` is false) makes Ionic throw
 * "Cannot read properties of null (reading 'props')" on mount, leaving the
 * whole app blank. Conditional routes are therefore added via array spread
 * (`...(cond ? [...] : [])`) so disabled routes are *omitted*, never rendered
 * as a falsy node. Do NOT inline `{cond && <Route/>}` as a direct outlet child.
 */
export function buildRouteChildren(presetsEnabled: boolean) {
  return [
    // New user-facing routes
    <Route key="group-detail-tab" path="/groups/:id/:tab" component={GroupDetail} exact />,
    <Route key="group-detail" path="/groups/:id" component={GroupDetail} exact />,
    <Route key="group-browse" path="/groups" component={GroupBrowse} exact />,

    // Presets admin tab (Phase 2 - Group D). Registered only when the build-time
    // feature flag is on; spread so the routes are omitted (not falsy) when off.
    ...(presetsEnabled
      ? [
          <Route key="preset-detail" path="/presets/:id" component={PresetDetail} exact />,
          <Route key="presets-browse" path="/presets" component={PresetsBrowse} exact />,
        ]
      : []),

    // Default redirect
    <Route key="root-redirect" path="/" exact>
      <Redirect to="/groups" />
    </Route>,

    // Catch-all — redirect unknown routes (e.g. legacy /admin bookmarks) to /groups
    <Route key="catch-all">
      <Redirect to="/groups" />
    </Route>,
  ];
}
